import "core-js/modules/es.array.join.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Duration from 'components/Duration';

// We don't need to add an extra screen-reader friendly
// aria-label as the regular readout is already readable.
// Adding the label leads to a double announcement.
var noLabel = function noLabel() {
  return null;
};
function FriendlyDuration(_ref) {
  var value = _ref.value,
    showSeconds = _ref.showSeconds;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Duration, {
    value: value,
    getLabel: noLabel
  }, function (_ref2) {
    var hours = _ref2.hours,
      minutes = _ref2.minutes,
      seconds = _ref2.seconds;
    var parts = [];
    if (hours > 0) {
      parts.push(t('hour_short', {
        count: hours
      }));
    }
    if (minutes > 0) {
      parts.push(t('minute_short', {
        count: minutes
      }));
    }
    if (showSeconds && (seconds > 0 || parts.length === 0)) {
      parts.push(t('second_short', {
        count: seconds
      }));
    }
    if (parts.length === 0) {
      // If everything is zero and seconds are hidden
      return t('minute_short', {
        count: minutes
      });
    }
    return parts.join(' ');
  });
}
export default FriendlyDuration;